import React, { useEffect } from "react";
import { loadTree } from "./loadTree";
import ImageBrandHilite from "./ImageBrandHilite";
import AllYourSiteMenu from "./AllYourSiteMenu";
import DashboardPublisher from "./DashboardPublisher";
import UserMenu from "./UserMenu";
import PublisherMenu from "./PublisherMenu";
import ManagePublisherMenu from "./ManagePublisherMenu";
import FinanceMenu from "./FinanceMenu";
import ManageFinanceMenu from "./ManageFinanceMenu";
import ReportPositionMenu from "./ReportPositionMenu";
import ReportMenu from "./ReportMenu";
import SupportMenu from "./SupportMenu";

export default function Sidebar({ openItem = null, activeItem = null }) {
  useEffect(() => {
    loadTree();
  }, []);

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <ImageBrandHilite />

      <div className="sidebar" id="sidebar" style={{ direction: "rtl" }}>
        <div style={{ direction: "rtl" }}>
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <DashboardPublisher activeItem={activeItem} />
              <ReportMenu activeItem={activeItem} />
              <AllYourSiteMenu activeItem={activeItem} />
              <PublisherMenu activeItem={activeItem} />
              <ReportPositionMenu activeItem={activeItem} />
              <FinanceMenu openItem={openItem} activeItem={activeItem} />
              <SupportMenu openItem={openItem} activeItem={activeItem} />
            </ul>
          </nav>
        </div>
      </div>
    </aside>
  );
}
